// extracted by mini-css-extract-plugin
module.exports = {"container":"bF","input":"bG","indicator":"bH","checked":"bI","label":"bJ","disabled":"bK"};